import {
    SET_PATH_NAME, 
    SET_TOKEN, 
    SET_LAB, 
    SET_USER, 
    UPDATE_TOKEN, 
    LOGOUT, 
    UserInterface,
    UPDATE_USER_PROFILE_STARTED, 
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_ERROR,
    SEARCH_STARTED,
    SEARCH_QUERY_CHANGE,
    SEARCH_SUCCESS,
    SearchResultInterface,
    SEARCH_END,
    LAB_UPDATE_START,
    LAB_UPDATE_END,
    LabInterface,
    FETCH_USERS_START,
    FETCH_USERS_SUCCESS,
    SET_MENU_STATUS,
    QuickAccess,
    FETCH_QUICK_ACCESS_START,
    FETCH_QUICK_ACCESS_SUCCESS,
    CREATE_NEW_USER_SUCCESS,
    CREATE_NEW_USER_START
} from './types';
export const setMenuStatusAction = (isOpen: boolean) => ({
    type        : SET_MENU_STATUS,
    isOpen
})
export const setPathNameAction = (path: string) => ({
    type        : SET_PATH_NAME,
    path
})
export const setTokenAction = (token: string) => ({
    type        : SET_TOKEN,
    token
})
export const setLabAction = (lab: any) => ({
    type        : SET_LAB,
    lab
})
export const setUserAction = (user: any) => ({
    type        : SET_USER,
    user
})
export const updateUserProfileStarded = () => ({
    type        : UPDATE_USER_PROFILE_STARTED,
})
export const updateUserProfileSuccess = (user: UserInterface) => ({
    type        : UPDATE_USER_PROFILE_SUCCESS,
    user
})
export const updateTokenAction = () => ({
    type        : UPDATE_TOKEN,
})
export const logOutAction = () => ({
    type        : LOGOUT,
})
export const changeSearchQueryAction = (q :string) => ({
    type       : SEARCH_QUERY_CHANGE,
    searchQuery : q
})
export const searchStarted = () => ({
    type        : SEARCH_STARTED
})
export const searchSuccessed = (result :SearchResultInterface) => ({
    type        : SEARCH_SUCCESS,
    result
})
export const searchEndAction = () => ({
    type        : SEARCH_END
})
export const updateLabStartAction = () => ({
    type        : LAB_UPDATE_START
})
export const updateLabSuccessAction = (lab :LabInterface) => ({
    type        : LAB_UPDATE_END,
    lab
})
export const fetchUsersStartAction = () => ({
    type        : FETCH_USERS_START
})
export const fetchUsersSuccessAction = (users :UserInterface[]) => ({
    type        : FETCH_USERS_SUCCESS,
    users
})
export const fetchQuickAccessSuccessAction = (quickAccess :QuickAccess[]) => ({
    type        : FETCH_QUICK_ACCESS_SUCCESS,
    quickAccess
})
export const fetchQuickAccessStartAction = () => ({
    type        : FETCH_QUICK_ACCESS_START
})
export const createNewUserStartAction = () => ({
    type        : CREATE_NEW_USER_START
})
export const createNewUserSuccessAction = () => ({
    type        : CREATE_NEW_USER_SUCCESS
})